import counterpart from 'counterpart';
import {parse} from 'query-string';
import $script from 'scriptjs';

const LOCAL_STORAGE_KEY = 'af-locale';

const locales = {
    en: "English",
    ja: "日本語",
    zh: "中文",
    es: "Español",
    fr: "Français",
    pt: "Português",
    de: "Deutsch",
    ru: 'Русский',
    ko: '한국어',
    translate: 'Translate On/Off',
};

const PHRASEAPP_CONFIG = {
    projectId: '5524d7b6001802106742909bf019d4e2',
    fullReparse: true,
    autoLowercase: false,
    sso: {
        enabled: true,
        identifier: 'appsflyer',
        provider: 'saml'
    }
};

const Translate = {
    counterpart: counterpart,
    serviceContext: "",

    setSelectedLocale: function () {
        // find the lang parameter from the URL and get it's value
        let QueryString = parse(location.search);
        // use lang URL parameter to find the desired language - if not exist - use default en.
        let locale = QueryString.lang === 'zh-cn' ? 'zh' : QueryString.lang;
        locale = locales[locale] && locale || (localStorage && localStorage.getItem(LOCAL_STORAGE_KEY)) || 'en';
        this.counterpart.setLocale(locale);
        if (localStorage) {
            localStorage.setItem(LOCAL_STORAGE_KEY, locale);
        }
        this.counterpart.setFallbackLocale('en');
    },

    addDefaultLocale: function (locale, serviceContext) {
        serviceContext = serviceContext || this.getServiceContext();
        if (locale && serviceContext) {
            let localeObj = {};
            localeObj[serviceContext] = locale;
            this.counterpart.registerTranslations('en', localeObj);
            this.addLocalesGlobal(); // Doing this to override the added locale with the global dictionary
        } else {
            console.log("Translation Error: you must provide a serviceContext (the service name registered in bouncer, ie. 'apps', 'dashboard'...) and a webpack localesContext that directs to your 'locales' folder [example: require.context('./locales', false, /^.*\.json$/)]");
        }
    },

    addLocalesGlobal: function () {
        if (window.AppsFlyer && window.AppsFlyer.locales) {
            Object.keys(window.AppsFlyer.locales)
                .forEach(locale => this.counterpart.registerTranslations(locale, window.AppsFlyer.locales[locale]));
        }
    },
    /**
     * @param callback - to be called after the in-context-editor script has run
     * @param {string} [branch] - optional, use a Phrase branch
     */
    initInContextEditor: function (callback, branch) {
        const executeCallback = function () {
            if (callback && typeof callback === 'function') callback();
        };
        if(!!window.PHRASEAPP_CONFIG) return executeCallback();
        if (branch) {
            PHRASEAPP_CONFIG.branch = branch;
        }
        window.PHRASEAPP_CONFIG = PHRASEAPP_CONFIG;
        const src = ['https://', 'phraseapp.com/assets/in-context-editor/2.0/app.js?', new Date().getTime()].join('');
        $script(src, executeCallback);
    },

    localizedString: function (key, attributes, serviceContext) {
        serviceContext = serviceContext || this.getServiceContext();
        try {
            key = `${serviceContext}.${key}`;
            if (!!window.PHRASEAPP_CONFIG) {
                return `{{__phrase_${key}__}}`;
            }
            return this.counterpart.translate(key, attributes);
        }
        catch (err) {
            console.log('Translation Issue, Translation Fallback to EN - Current Locale: ' + this.counterpart.getLocale() + ' | Key: ' + key + ' | Error Message: ' + err.message);
            try {
                let setAttributes = attributes || {};
                setAttributes.locale = this.counterpart.getFallbackLocale();
                return this.counterpart.translate(key, setAttributes);
            } catch (err) {
                console.log('Translation Issue, Translation Fallback empty string');
            }
        }
    },

    currentLocale: function () {
        let locale = this.counterpart.getLocale();
        return locale === 'zh' ? 'zh-cn' : locale;
    },

    localeName: function (key) {
        return locales[key === 'zh-cn' ? 'zh' : key] || locales['en'];
    },

    getServiceContext: function () {
        if (!this.serviceContext) {
            this.setServiceContext();
        }
        return this.serviceContext;
    },

    setServiceContext: function (serviceContext) {
        if (typeof serviceContext === 'string' && serviceContext.trim()) {
            this.serviceContext = serviceContext.trim();
            return;
        }
        this.serviceContext = location.pathname.split('/')[1];
    }
};

function init() {
    Translate.setSelectedLocale();
    Translate.addLocalesGlobal();
}

init();

export default Translate;
